/** Montants en euros, sans décimales : l'association ne facture pas au centime. */
export const euros = new Intl.NumberFormat('fr-FR', {
  style: 'currency',
  currency: 'EUR',
  maximumFractionDigits: 0,
});
